import {
  Disclosure as DisclosureWrapper,
  DisclosureButton,
  DisclosurePanel,
  Transition,
} from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

import Typography from '~/shared/components/Typography';

interface DisclosureItem {
  label: string;
  onClick: () => void;
}

interface DisclosureProps {
  title?: string;
  count?: number;
  items?: DisclosureItem[];
  open: boolean; // controlled mode only
  onOpenChange: (isOpen: boolean) => void; // controlled mode only
  className?: string;
  buttonClassName?: string;
  panelClassName?: string;
  itemClassName?: string;
  chevronClassName?: string;
  children: React.ReactNode;
}

export default function FiltersDisclosure({
  title,
  count,
  open,
  onOpenChange,
  className = '',
  buttonClassName = '',
  panelClassName = '',
  chevronClassName = '',
  children,
}: DisclosureProps): React.ReactElement {
  return (
    <div className={clsx('w-full max-w-md  ', className)}>
      <DisclosureWrapper>
        <DisclosureButton
          onClick={() => onOpenChange(!open)}
          className={clsx('w-full text-left flex justify-between items-center ', buttonClassName)}
        >
          <div className="flex items-center gap-2">
            <Typography
              fontWeight={600}
              variant="p2"
              color="font-family-outfit text-primary-900  cursor-pointer py-3"
            >
              {title}
            </Typography>
            {count !== undefined && (
              <Typography
                fontWeight={500}
                variant="p3"
                className="font-family-inter text-white bg-primary-700 rounded size-6 grid place-items-center"
              >
                {count}
              </Typography>
            )}
          </div>
          <ChevronDownIcon
            className={clsx(
              'w-[16px] h-[16px] text-grey-600 stroke-2  cursor-pointer transition-transform duration-200 ease-in-out',
              open ? 'rotate-180' : '',
              chevronClassName
            )}
          />
        </DisclosureButton>

        <Transition
          show={open}
          enter="transition-all duration-200 ease-out"
          enterFrom="max-h-0 opacity-0"
          enterTo="max-h-[500px] opacity-100"
          leave="transition-all duration-200 ease-in"
          leaveFrom="max-h-[500px] opacity-100"
          leaveTo="max-h-0 opacity-0"
        >
          <DisclosurePanel static className={clsx('overflow-hidden flex flex-col', panelClassName)}>
            {children}
          </DisclosurePanel>
        </Transition>
      </DisclosureWrapper>
    </div>
  );
}
